import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_MASSOPS = `${URL_APP_ADMIN}/massops`
const URL_MASSOPS_DASHBOARD = `${URL_MASSOPS}/dashboard`
const URL_MASSOPS_EVENTS_LIST_LANDING = `${URL_MASSOPS}/interventions`
const URL_MASSOPS_INTERVENTION = `${URL_MASSOPS}/intervention/:interventionId`
const URL_MASSOPS_CREATE_INTERVENTION = `${URL_MASSOPS}/create-intervention`
const URL_MASSOPS_CREATE_INTERVENTION_BUNDLE = `${URL_MASSOPS}/create-intervention-bundle`
const URL_MASSOPS_INTERVENTION_BUNDLES = `${URL_MASSOPS}/intervention-bundles`
const URL_MASSOPS_INTERVENTION_BUNDLE = `${URL_MASSOPS}/intervention-bundle/:bundleUuid`
const URL_MASSOPS_INTERVENTION_SETTINGS = `${URL_MASSOPS}/intervention/:interventionId/settings`
const URL_MASSOPS_APPROVAL_REQUEST = `${URL_MASSOPS}/approval-request/:approvalRequestId`
const URL_MASSOPS_ADMIN = `${URL_MASSOPS}/admin`
const URL_MASSOPS_CHAT = `${URL_MASSOPS}/chat`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'massops'>
  | DashRouteType<'massops-dashboard'>
  | DashRouteType<'massops-interventions'>
  | DashRouteType<'massops-intervention', { interventionId?: string }>
  | DashRouteType<'massops-create-intervention'>
  | DashRouteType<'massops-create-intervention-bundle'>
  | DashRouteType<'massops-intervention-bundles'>
  | DashRouteType<'massops-intervention-bundle', { bundleUuid?: string }>
  | DashRouteType<'massops-intervention-settings', { interventionId?: string }>
  | DashRouteType<'massops-approval-request', { approvalRequestId?: string }>
  | DashRouteType<'massops-admin'>
  | DashRouteType<'massops-chat'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  massops: URL_MASSOPS,
  'massops-dashboard': URL_MASSOPS_DASHBOARD,
  'massops-interventions': URL_MASSOPS_EVENTS_LIST_LANDING,
  'massops-intervention': URL_MASSOPS_INTERVENTION,
  'massops-create-intervention': URL_MASSOPS_CREATE_INTERVENTION,
  'massops-create-intervention-bundle': URL_MASSOPS_CREATE_INTERVENTION_BUNDLE,
  'massops-intervention-bundles': URL_MASSOPS_INTERVENTION_BUNDLES,
  'massops-intervention-bundle': URL_MASSOPS_INTERVENTION_BUNDLE,
  'massops-intervention-settings': URL_MASSOPS_INTERVENTION_SETTINGS,
  'massops-approval-request': URL_MASSOPS_APPROVAL_REQUEST,
  'massops-admin': URL_MASSOPS_ADMIN,
  'massops-chat': URL_MASSOPS_CHAT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
